import { render } from "./JobView.vue?vue&type=template&id=08d46afe"
import script from "./JobView.vue?vue&type=script&lang=js"
export * from "./JobView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__